export enum RoutePaths {
  home = "/",
  gallery = "/gallery/:gallery",
  about = "/about",
  share = "/share",
  social = "/social",
}
